/**
 * <s-sticky-atc>: mobile buy bar that slides in once the main add-to-cart
 * button has scrolled above the viewport. It lives inside the product-form
 * partial, so price and availability refresh with variant changes; the bar's
 * button submits the main form through the `form` attribute.
 */
class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.inert = true;
    requestAnimationFrame(() => {
      const target = document.querySelector('[data-main-atc]');
      if (!target) return;
      this.observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', scrolledPast);
        this.inert = !scrolledPast;
      });
      this.observer.observe(target);
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', StickyAtc);
